var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHideFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.108 4.092 4.195 3l3.032 3.045c1.409-.581 3-.967 4.743-.967h.06c6.918 0 11.444 6.066 11.635 6.33l.335.46-.335.453c-.127.17-2.163 2.87-5.54 4.667l2.906 2.92L19.943 21l-3.308-3.322-.013.005-2.208-2.217a4.346 4.346 0 1 0-6.006-6.031L5.745 6.758l.012-.006-2.648-2.66ZM7.81 10.816 4.515 7.51C1.956 9.231.444 11.261.336 11.407l-.336.46.335.454c.19.256 4.717 6.257 11.635 6.257h.06a12.16 12.16 0 0 0 3.103-.406L13.03 16.06a4.346 4.346 0 0 1-5.22-5.243Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.162 12.176a2.896 2.896 0 0 0 2.514 2.524l-2.514-2.524ZM13.357 14.404l-3.891-3.908a2.894 2.894 0 1 1 3.891 3.908Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHideFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HideFilled.0e530e0da1c8aa2fdad99bc5c1e6362a.svg";